import React, { useState, useEffect } from 'react'
import ContentBox from '../components/ContentBox'
import Header from '../components/home/Header';
import ParametrosApi from 'services/robinhood/ParametrosApi';


export default function Historicos() {
  const [anosDecreto, setAnosDecreto] = useState(0);
  const [historico, setHistorico] = useState();
  useEffect(() => {
    document.getElementById('toggle-menu').className = 'theme-blush ls-toggle-menu';
    setAnosDecreto(getAnosDesde('06/01/1991'));
    start();

  }, []);

  const start = async () => {
    new ParametrosApi().all().then(response => {
      if (response.length > 0) {
        const historicoTexto = response.filter(paramentro => paramentro.id == new ParametrosApi().historicos_texto);
        setHistorico(historicoTexto[0].valor);
      }
    });
  }

  const getAnosDesde = (_desde) => {
    let dob = new Date(_desde);
    let month_diff = Date.now() - dob.getTime();
    let age_dt = new Date(month_diff);
    let year = age_dt.getUTCFullYear();
    let age = Math.abs(year - 1970);
    return age;
  };

  return (
    <>
      <section className="content">
        <Header>
          <h5 style={{ marginLeft: '8px', marginBottom: '' }}> <i className='zmdi zmdi-calendar'></i> HISTÓRICO  </h5>
        </Header>
        <div class="col-lg-4 col-sm-6 col-md-6 col-xs-12" style={{ marginBottom: '-30px' }}>
          <div class="card bg-blue-grey">
            <div class="body text-white">
              <h4><i className='zmdi zmdi-calendar' style={{ fontSize: '30px' }}></i> {anosDecreto} ANOS DE DECRETO</h4>
              <span className='m-l-30'>DESDE JULHO DE 1991</span>
            </div>
          </div>
        </div>
      </section>
      <section class="content">
        <div className='container-fluid'>
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="card">
                <div className="header">
                  <h2> O HISTÓRICO DA LEI ROBIN HOOD   </h2>
                  <hr />
                </div>
                <div className="body">
                  <div className="row clearfix">
                    <div className="col-md-12 col-lg-12" dangerouslySetInnerHTML={{ __html: historico }}>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  )
}
